import React, { useState } from "react";
import SignupForm from "./SignupForm";
import Logo from "./components/Logo";
import { useMatch, Link, useNavigate } from "react-router-dom";
import logoRed from "./branding/thefeedgram.svg";
import "./PasswordResetPage.css";
import ResetPasswordMutation from "./mutations/ResetPasswordMutation";
import { ToastContainer, toast } from "react-toastify";

function ForgotPasswordPage(props) {
	// const { router, match } = useRouter();
    const navigate = useNavigate();
    const match = useMatch();
	const [password, setPassword] = useState("");
	const [rePassword, setRePassword] = useState("");

	const token = match.params.token;
	const uid = match.params.uid;
	const messageSuccess = () => toast("Reset password successfully!");

	function onResetPasswordFormSubmit(e) {
		e.preventDefault();
		// Reset mutation
		navigate("/login");
	}

	function onSubmit(e) {
		e.preventDefault();

		ResetPasswordMutation(uid, token, password, () => {
			messageSuccess();
			// navigate('/login');
			console.log("Reset password successfully!");
		});

		console.log("Password: " + password);
		console.log("Re-Password: " + rePassword);
	}

	console.log("uid: " + match.params.uid);
	console.log("token: " + token);

	return (
		<div className="reset-container">
			<ToastContainer
				position="bottom-right"
				autoClose={5000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<div className="reset-header">
				<div className={`reset-header-room`}>
					<div className="component-box">
						<Link to="/">
							<img className="brand-logo" src={logoRed} alt="" />
						</Link>
						<Link
							className="auth-action-button auth-signin"
							to="/login"
						>
							Login
						</Link>

						<div className="reset-wrapper">
							<div className="loginform-container">
								<label className="login-title">
									{" "}
									Reset password{" "}
								</label>
								<form
									onSubmit={onSubmit}
									className="reset-form"
								>
									<input
										placeholder="Password"
										className="standard-textfield auth-textfield"
										name="password"
										type="password"
										onChange={e =>
											setPassword(e.target.value)
										}
									/>

									<input
										placeholder="Repeat Password"
										className="standard-textfield auth-textfield"
										name="re-password"
										type="password"
										onChange={e =>
											setRePassword(e.target.value)
										}
									/>
									<input
										className="standard-action-button"
										type="submit"
										value="Submit"
									/>
								</form>
							</div>
							{/*
								<div className="terms-conditions">
									<Link to="/terms">Terms</Link>
									<Link to="/terms">Privacy</Link>
								</div>
							*/}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ForgotPasswordPage;
